import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatMoney } from 'lib/utils';
import { standingOrdersRecurringNames } from 'lib/constants';

import { StandingOrder } from 'lib/type';

interface StandingOrderItemProps {
    item: StandingOrder;
}

const StandingOrderItem = ({ item }: StandingOrderItemProps) => {
    const navigate = useNavigate();

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div // NOSONAR: styled via .menu-item-container which relies on div defaults
            className="menu-item-container"
            onClick={() => navigate(`/payments/standing-order/${item.id}`)}
        >
            <div className="menu-item-left">
                <h2 className="menu-item-left-title">{item.payeeName}</h2>
                <h3 className="menu-item-left-date">
                    {standingOrdersRecurringNames[item.recurType]}
                </h3>
            </div>
            <div className="menu-item-right">
                <h2 className="menu-item-right-amount">
                    £{formatMoney(item.amount)}
                </h2>
                <div className="menu-item-arrow">
                    <i className="fa fa-caret-right" />
                </div>
            </div>
        </div>
    );
};

export default StandingOrderItem;
